import { render } from "./StudentMotivation.vue?vue&type=template&id=6c97816a&scoped=true"
import script from "./StudentMotivation.vue?vue&type=script&lang=js"
export * from "./StudentMotivation.vue?vue&type=script&lang=js"

import "./StudentMotivation.vue?vue&type=style&index=0&id=6c97816a&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/studyflow-frontend/studyflow-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c97816a"]])

export default __exports__